import { render, staticRenderFns } from "./ManageUserRole.vue?vue&type=template&id=073b9afc"
import script from "./ManageUserRole.vue?vue&type=script&lang=js"
export * from "./ManageUserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports